export default "__VITE_ASSET__DGVJh0Sg__"